module.exports = __webpack_public_path__ + "img/U1F62D.99155074.png";